import {
  Autocomplete,
  Backdrop,
  Box,
  CircularProgress,
  FormControl,
  Tab,
  Tabs,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import HttpService from '../../hooks/Https-services';
import { API_ROUTES } from '../../utils/constant';
import moment from 'moment';
import ReactApexChart from 'react-apexcharts';
type ChartSeries = {
  name: string;
  data: number[];
};
type ChartData = {
  series: ChartSeries[];
  categories: string[];
};

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      sx={{ p: 3 }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

const TeamHoursChart = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = React.useState<any[]>([]);
  const [selectedTeams, setSelectedTeams] = React.useState<any>([]);
  const [selectedTeamsKeys, setSelectedTeamsKeys] = React.useState<any[]>([]);
  const [chartData, setChartData] = useState<ChartData>({
    series: [],
    categories: [],
  });
  const [isTeamLoaded, setIsTeamLoaded] = React.useState(false);

  const fetchTeamsList = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await HttpService.get(API_ROUTES.fatchAllTeam);
      const teamsData = response.data.data;
      setTeams(teamsData);
      // Select all teams except the one with id 1
      const defaultSelectedTeams = teamsData.filter(
        (team: any) => team.id !== 1
      );
      setIsTeamLoaded(true);
      setSelectedTeams(defaultSelectedTeams);
      setSelectedTeamsKeys(defaultSelectedTeams.map((team: any) => team.id));
    } catch (error) {
      setIsTeamLoaded(true);
      console.error('Error fetching teams list:', error);
      setTeams([]); // Reset to avoid undefined
    } finally {
      setIsTeamLoaded(true);
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchTeamsList();
  }, [fetchTeamsList]);
  const handleChangeTeams = (event: any, newValue: any) => {
    setSelectedTeams(newValue);
    const selectedKeys = newValue?.map((option: any) => option.id);
    setSelectedTeamsKeys(selectedKeys);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  const getTableData = async () => {
    setLoading(true);
    try {
      const query: any = {};
      query.teamIds = selectedTeamsKeys || [];
      query.roleId = tabIndex === 0 ? 2 : 3;
      const response = await HttpService.get(
        `${API_ROUTES.hourlyActivitySummaryGraph}?${new URLSearchParams(query).toString()}`
      );
      const apiData = response?.data?.data || [];
      const categories = apiData.map((item: { startTime: any }) =>
        moment(item.startTime).format('DD-MM-YYYY HH:mm:ss')
      );
      const series = [
        {
          name: 'Active Count',
          data: apiData.map((item: { activeCount: any }) => item.activeCount),
        },
        {
          name: 'Idle Count',
          data: apiData.map((item: { idealCount: any }) => item.idealCount),
        },
      ];
      setChartData({ series, categories });
    } catch (error) {
      console.error('Error fetching chart data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    isTeamLoaded && getTableData();
  }, [tabIndex, selectedTeamsKeys]);

  const chartOptions: any = {
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
        // events: {
        //   dataPointSelection: (event: any, chartContext: any, config: any) => {
        //     const { seriesIndex, dataPointIndex } = config;
        //     const category = chartData.categories[dataPointIndex];
        //     const seriesName = chartData.series[seriesIndex].name;

        //     console.log(
        //       `Bar clicked! Category: ${category}, Series: ${seriesName}`
        //     );

        //     // Navigate to a new page or perform an action
        //     // Example: Navigate to a page with category details
        //     // window.location.href = `/details/${category}`;
        //   },
        // },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '13px',
                fontWeight: 900,
              },
            },
          },
        },
      },
      xaxis: {
        type: 'date',
        categories: chartData.categories,
      },
      legend: {
        position: 'right',
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
      title: {
        text: 'Hourly Activity Summary',
        align: 'left',
        style: {
          fontSize: '16px',
        },
      },
      colors: ['#eb6f33', '#d30584'],
    },
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        aria-label="Dashboard Tabs"
      >
        <Tab label="MODERATOR" />
        <Tab label="TAGGER" />
      </Tabs>
      <Box sx={{ display: 'flex', gap: 2, margin: '10px 0' }}>
        <FormControl
          sx={{
            flexShrink: 0,
            width: { xs: 1, md: '300px' },
            margin: '0 !important',
            padding: '0 !important',
          }}
        >
          <Autocomplete
            size="small"
            multiple
            fullWidth
            id="role-selector"
            options={teams}
            value={selectedTeams} // Replace with your selected roles state
            getOptionLabel={(option: any) => option.userTeamKey}
            onChange={(event, newValue) => {
              handleChangeTeams(event, newValue); // Replace with your role change handler
            }}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Teams" />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
        </FormControl>
      </Box>

      <TabPanel
        value={tabIndex}
        index={0}
        sx={
          {
            // padding: '0px !important',
            // margin: '0px !important',
          }
        }
      >
        {chartData.series.length > 0 && chartData.categories.length > 0 && (
          <ReactApexChart
            options={chartOptions.options}
            series={chartData.series}
            type="bar"
            height={400}
          />
        )}
      </TabPanel>
      <TabPanel
        value={tabIndex}
        index={1}
        sx={
          {
            // padding: '0px !important',
            // margin: '0px !important',
          }
        }
      >
        {chartData.series.length > 0 && chartData.categories.length > 0 && (
          <ReactApexChart
            options={chartOptions.options}
            series={chartData.series}
            type="bar"
            height={400}
          />
        )}
      </TabPanel>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default TeamHoursChart;
